/* gparap (c) 2024 */
import logo from './logo.png';
import './App.css';
import Carousel from './components/Carousel';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


function App() {
  return (
    <div className='container'>
      <BrowserRouter basename="/projects/react/image-gallery">
        <Routes>
          <Route path='/' element={<App />} />
        </Routes>
      </BrowserRouter>
      <header className="App App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <br />
      </header>
      <div className='carousel-container'>
        <Carousel />
      </div>
    </div>
  );
}

export default App;
